// src/components/GridView/GridColumnHeader.ts
import type { GridColumn } from './types';

/** Escapes HTML special characters to prevent XSS in innerHTML strings */
function escHtml(str: string): string
{
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Builds the HTML string for a column header (goes inside HOT's sort button).
 *
 * IMPORTANT: HOT wraps this string in a <button> when columnSorting is active,
 * so only phrasing content (spans, not divs) is allowed here.
 *
 * The colored top bar for dynamic columns is injected separately via the
 * afterGetColHeader hook in GridView, directly on the <th> DOM element.
 *
 * Fixed columns  → plain label span.
 * Dynamic columns → field-name span + layer-name span.
 */
export function buildColumnHeader(column: GridColumn): string
{
  return `<span class="gridview-col-header-title">${escHtml(column.title)}</span>`;
}
